// extracted by css-extract-rspack-plugin
export default {"container":"ZendeskChat-module__container","closeIcon":"ZendeskChat-module__closeIcon"};